import axios from "axios";
import * as ActionType from "./user.type";
import { Navigate, useNavigate } from "react-router-dom";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";
import { baseURL } from "../../../util/config";
export const getUser =
  (type, start, limit, startDate, endDate) => (dispatch) => {
    axios
      .get(
        `${baseURL}admin/user/getUsers?type=${type}&start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`
      )
      .then((res) => {
        dispatch({
          type: ActionType.GET_USER,
          payload: {
            user: res.data.users,
            totalUser: res.data.totalUsers,
          },
        });
      })
      .catch((error) => console.error(error));
  };
export const getAllUsers =
  (type, start, limit, startDate, endDate) => (dispatch) => {
    axios
      .get(
        `${baseURL}admin/user/getAllUsers?type=${type}&start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`
      )
      .then((res) => {
        dispatch({
          type: ActionType.GET_ALL_USER,
          payload: {
            allUsers: res.data.users,
          },
        });
      })
      .catch((error) => console.error(error));
  };
export const deleteChannel =
  (channelId, type, start, limit, startDate, endDate) => (dispatch) => {
    console.log(channelId);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${baseURL}admin/user/deleteChannel?channelId=${channelId}`,
      headers: {
        key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W",
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response);
        setToast("success", response.data.message);
        dispatch(getUser(type, start, limit, startDate, endDate));
      })
      .catch((error) => {
        console.log(error);
      });
  };
export const isActiveUser = (id, type, data) => (dispatch) => {
  axios
    .patch(`${baseURL}admin/user/isBlock?userId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.ACTIVE_SWITCH_USER,
          payload: { data: res.data.users, id: id, type: type },
        });
        setToast(
          "success",
          data === true
            ? `User Block SuccessFully`
            : "User Unblock SuccessFully"
        );
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const deleteUser = (id, type) => (dispatch) => {
  axios
    .delete(`${baseURL}admin/user/deleteUsers?userId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_USER,
          payload: { id: id, type: type },
        });
        setToast("success", "User Delete SuccessFully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

export const getUserProfile = (id) => (dispatch) => {
  axios
    .get(`${baseURL}admin/user/getProfile?userId=${id}`)
    .then((res) => {
      dispatch({ type: ActionType.GET_USER_PROFILE, payload: res.data.user });
    })
    .catch((error) => console.error(error));
};

export const getCountry = () => (dispatch) => {
  fetch("https://restcountries.com/v3.1/all?fields=name")
    .then((response) => response.json())
    .then((data) => {
      dispatch({ type: ActionType.GET_COUNTRY, payload: data });
    })
    .catch((error) => {
      console.error(error);
    });
};

export const editUserProfile = (id, data, isChannel) => (dispatch) => {
  axios
    .patch(
      `${baseURL}admin/user/updateUser?userId=${id}&isChannel=${isChannel}`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.USER_EDIT_PROFILE,
          payload: { data: res.data.user, id: id },
        });
        setToast(
          "success",
          `${res.data.user.fullName + " " + "Update SuccessFully"} `
        );
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const createFakeUser = (formData) => (dispatch) => {
  axios
    .post(`${baseURL}admin/user/fakeUser`, formData)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({ type: ActionType.CREATE_FAKE_USER, payload: res.data.user });
        setToast("success", "Fake User created Successfully !");
      }
    })
    .catch((error) => console.error(error));
};

export const getIpAddress = () => (dispatch) => {
  fetch("https://api.ipify.org?format=json")
    .then((response) => response.json())
    .then((data) => {
      dispatch({ type: ActionType.GET_IP_ADDRESS, payload: data });
    })
    .catch((error) => {
      console.error("Error fetching IP address:", error);
    });
};

export const getFakeUser =
  (start, limit, startDate, endDate, type) => (dispatch) => {
    axios
      .get(
        `${baseURL}admin/user/getUsers?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&type=${type}`
      )
      .then((res) => {
        dispatch({
          type: ActionType.GET_FAKE_USER,
          payload: {
            data: res.data.users,
            total: res.data.totalUsersAddByAdmin,
          },
        });
      })
      .catch((error) => console.error(error));
  };

export const passwordChange = (id, data) => (dispatch) => {
  axios
    .patch(`${baseURL}admin/user/updatePassword`, data)
    .then((res) => {
      if (res.status) {
        dispatch({
          type: ActionType.PAASWORD_CHANGE_API,
          payload: { data: res.data.user, id: id },
        });

        setToast("success", "Password Change SuccessFully");
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const getUserChannels =
  (start, limit, startDate, endDate, type) => (dispatch) => {
    axios
      .get(
        `${baseURL}admin/user/channelsOfUser?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&type=${type}`
      )
      .then((res) => {
        dispatch({
          type:
            type == "realUser"
              ? ActionType.GET_USER_CHANNEL_DATA
              : ActionType.GET_FAKE_USER_CHANNEL_DATA,
          payload: {
            channel: res.data.channels,
            total: res.data.totalChannels,
          },
        });
      })
      .catch((error) => console.error(error));
  };

export const createChannelFakeUser = (id, createChannel) => (dispatch) => {
  axios
    .patch(
      `${baseURL}admin/user/updateUser?userId=${id}&isChannel=false`,
      createChannel
    )
    .then((res) => {
      if (res.data.status) {
        const channelData = res.data.user;
        const type = ActionType.CREATE_FAKE_USER_CHANNEL;
        dispatch({
          type,
          payload: { channelData, id, type },
        });
        setToast("success", "Channel Create SuccessFully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const getFakeUserName = () => (dispatch) => {
  console.log("username");
  axios
    .get(`${baseURL}admin/user/getUsersAddByAdminForChannel`)
    .then((res) => {
      console.log(res);
      dispatch({
        type: ActionType.GET_FAKE_USER_NAME,
        payload: res.data.users,
      });
    })
    .catch((error) => console.error(error));
};

export const getSubscriberAndUnsubscribers = (id) => (dispatch) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${baseURL}client/userWiseSubscription/subscribeandunsubscribeusers?userId=${id}`,
    headers: {
      key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W",
    },
  };

  axios
    .request(config)
    .then((response) => {
      if (response.data.status) {
        console.log(response.data);
        dispatch({
          type: ActionType.GET_SUBSCRIBE_AND_UNSUBSCRIBE,
          payload: {
            subscribers: response.data.subscribers,
            unSubscribers: response.data.unSubscribers,
          },
        });
        setToast("success", response.data.message);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
export const updatingSubscribersAndUnsubscribers = (
  subscribers,
  unSubscibers
) => {
  console.log("unSubscribers", unSubscibers);
  console.log("subscribers", subscribers);
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseURL}client/userWiseSubscription/updatingTheSubscribeAndUnsubscribe`,
    headers: {
      key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W",
      "Content-Type": "application/json",
    },
    data: { subscribers: subscribers, unSubscribers: unSubscibers },
  };
  axios
    .request(config)
    .then((response) => {
      if (response.data.status) {
        setToast("success", response.data.message);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateFeature =
  (id, checked, start, limit, startDate, endDate, type) => (dispatch) => {
    console.log(type, start, limit, startDate, endDate);

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${baseURL}admin/user/updateFeatureChannel?feature=${checked}&id=${id}`,
      headers: {
        key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W",
      },
    };
    axios
      .request(config)
      .then((res) => {
        if (res.data.status) {
          dispatch(getUserChannels(start, limit, startDate, endDate, type));
          setToast("success", res.data.message);
        }
      })
      .catch((error) => console.log(error));
  };
export const updateProfile = (userId, isPremium) => (dispatch) => {
  let data = JSON.stringify({
    isPremiumPlan: isPremium,
  });

  let config = {
    method: "patch",
    maxBodyLength: Infinity,
    url: `${baseURL}admin/user/updateProfile?userId=${userId}`,
    headers: {
      key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W",
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios
    .request(config)
    .then((res) => {
      console.log(JSON.stringify(res.data.user.isPremiumPlan));
      if (res.data.status) {
        setToast("success", `Premium Plan is updated now`);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
